module.exports = __webpack_public_path__ + "images/emoji/gem.8df09c1171a2c98b6979.png";